import LegalPage from "../../components/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      badge="Legal"
      title="Privacy Policy"
      lastUpdated="Feb 1, 2026"
      sections={[
        {
          heading: "Overview",
          paragraphs: [
            "This Privacy Policy describes how Brivo360 ('Brivo', 'we', 'our') collects, uses, shares, and protects information when you use our website, applications, and services.",
            "We respect your privacy and are committed to handling your data responsibly. This policy is written in plain English — no fine print games.",
          ],
        },
        {
          heading: "Information We Collect",
          paragraphs: ["We collect the following categories of information:"],
          bullets: [
            "Account information: name, email, phone, company, billing details.",
            "Usage data: pages visited, features used, click events, IP address, device and browser type.",
            "Customer business data: products, orders, transactions, customer records you input into Brivo.",
            "Communications: emails and chat messages exchanged with our support team.",
          ],
        },
        {
          heading: "How We Use Your Information",
          paragraphs: ["We use your information to:"],
          bullets: [
            "Operate and maintain the Service.",
            "Process payments and prevent fraud.",
            "Send transactional emails (receipts, account notices) and product updates.",
            "Improve our Service through analytics and aggregated insights.",
            "Comply with legal obligations.",
          ],
        },
        {
          heading: "Sharing Your Information",
          paragraphs: ["We do not sell your data. Ever. We share information only with:"],
          bullets: [
            "Service providers who help us operate (e.g., cloud hosting, payment processors), bound by strict confidentiality obligations.",
            "Law enforcement, when required by valid legal process.",
            "Successors in the event of a merger or acquisition (with notice to you).",
          ],
        },
        {
          heading: "Your Rights",
          paragraphs: ["Depending on your jurisdiction (GDPR, CCPA, LGPD, etc.), you may have the right to access, correct, delete, or export your data, or to restrict its processing. To exercise these rights, email privacy@brivo.app — we respond within 30 days."],
        },
        {
          heading: "Data Retention",
          paragraphs: ["We retain account data for as long as your account is active. Upon cancellation, data is retained for 90 days, then deleted unless required by law to retain longer (e.g., tax records)."],
        },
        {
          heading: "Security",
          paragraphs: ["Brivo employs bank-grade security: AES-256 encryption at rest, TLS 1.3 in transit, SOC 2 Type II audited. While no system is 100% secure, we treat your data like our own and continuously invest in safeguards."],
        },
        {
          heading: "Children",
          paragraphs: ["Brivo is not intended for individuals under 18. We do not knowingly collect data from children. If you believe we have, contact us and we will delete it promptly."],
        },
        {
          heading: "International Data Transfers",
          paragraphs: ["Brivo operates globally. Your data may be processed in jurisdictions other than your own. Where required, we use Standard Contractual Clauses or other valid mechanisms to ensure adequate protection."],
        },
        {
          heading: "Contact",
          paragraphs: ["For privacy questions, email privacy@brivo.app or write to: Brivo360, Attention: Data Protection Officer, 1 Market Street, Suite 200, San Francisco, CA 94105."],
        },
      ]}
    />
  );
}
